<div class="toolkit__filtersBar">
	<select class="toolkit__filterSelect" [(ngModel)]="vm.clientTheme" (ngModelChange)="vm.applyClientFilters()">
		<option value="ALL">{{ 'Toolkit.Clients.Filters.Theme.All' | translate }}</option>
		<option *ngFor="let t of (vm.themes || [])" [value]="t.id">{{ vm.themeName(t.id) | translate }}</option>
	</select>

	<select class="toolkit__filterSelect" [(ngModel)]="vm.clientStatus" (ngModelChange)="vm.applyClientFilters()">
		<option value="ALL">{{ 'Toolkit.Clients.Filters.Status.All' | translate }}</option>
		<option value="ACTIVE">{{ 'Toolkit.Status.Active' | translate }}</option>
		<option value="OVERDUE">{{ 'Toolkit.Status.Overdue' | translate }}</option>
		<option value="DONE">{{ 'Toolkit.Status.Done' | translate }}</option>
		<option value="NEW">{{ 'Toolkit.Status.NewClient' | translate }}</option>
	</select>

	<select class="toolkit__filterSelect" [(ngModel)]="vm.clientSort" (ngModelChange)="vm.applyClientFilters()">
		<option value="next_session">{{ 'Toolkit.Clients.Sort.NextSession' | translate }}</option>
		<option value="name">{{ 'Toolkit.Clients.Sort.Name' | translate }}</option>
	</select>

	<input
		type="text"
		class="toolkit__filterSearch"
		placeholder="{{ 'Toolkit.Clients.Search.Placeholder' | translate }}"
		spellcheck="false"
		[(ngModel)]="vm.clientSearch"
		(ngModelChange)="vm.applyClientFilters()">

	<button class="toolkit__filterReset" type="button" (click)="vm.resetClientFilters()">{{ 'Toolkit.Clients.Filters.Reset' | translate }}</button>
</div>

<div class="toolkit__clientRoster">
	<div
		class="toolkit__clientCard"
		[ngClass]="{ 'toolkit__clientCard--prompt-highlight': clientSummary(c)?.highlightReassessment }"
		*ngFor="let c of vm.filteredClients">
		<ng-container *ngIf="clientSummary(c) as s">
			<div class="toolkit__clientCardHead">
				<div class="toolkit__avatar toolkit__avatar--md">{{ vm.initials(c) }}</div>
				<div class="toolkit__clientNameBlock">
					<button type="button" class="toolkit__clientName" (click)="vm.openClientRoute(c)">{{ c.firstname }} {{ c.lastname }}</button>
					<div class="toolkit__clientMeta"><strong>{{ vm.getClientSessionLabel(c) }}</strong></div>
				</div>
				<span class="toolkit__statusPill status-pill" [ngClass]="statusPill(s).cls">
					<span class="pill-dot"></span>
					<ng-container *ngIf="statusPill(s).translate; else literalStatus">
						<span>{{ statusPill(s).key | translate }}</span>
					</ng-container>
					<ng-template #literalStatus>
						<span>{{ statusPill(s).key }}</span>
					</ng-template>
					<span *ngIf="statusPill(s).count && statusPill(s).count > 0 && statusPill(s).cls === 'pill-overdue'">({{ statusPill(s).count }})</span>
				</span>
			</div>
			<div class="toolkit__themeTags" *ngIf="c.themeKeys?.length">
				<span class="toolkit__themeTag" *ngFor="let t of c.themeKeys">{{ t | translate }}</span>
			</div>
			<div class="toolkit__statsRow">
				<div class="toolkit__stat">
					<div class="toolkit__statLabel">{{ 'Toolkit.Format.Exercise' | translate }}</div>
					<div class="toolkit__statText">
						<div class="progress-cell">
							<div class="progress-track">
								<div
									class="progress-fill"
									[ngClass]="progressFillClass(s.toolsCompleted, s.toolsTotal)"
									[style.width.%]="progressPercent(s.toolsCompleted, s.toolsTotal)"></div>
							</div>
							<span class="progress-text">{{ s.toolsCompleted }} / {{ s.toolsTotal }}</span>
						</div>
					</div>
				</div>
				<div class="toolkit__stat">
					<div class="toolkit__statLabel">{{ c.planProgress ? ('Toolkit.Clients.Stats.Eek2Plan' | translate) : ('Toolkit.Clients.Stats.Surveys' | translate) }}</div>
					<div class="toolkit__statText">
						<ng-container *ngIf="c.planProgress; else surveysMeter">
							<div class="progress-cell progress-cell--plan">
								<div class="toolkit__planTrack" aria-hidden="true">
									<ng-container *ngFor="let node of planNodes(c); let last = last">
										<span class="toolkit__planNode" [ngClass]="'toolkit__planNode--' + node"></span>
										<span *ngIf="!last" class="toolkit__planLine" [ngClass]="{ 'toolkit__planLine--done': node === 'done' }"></span>
									</ng-container>
								</div>
								<span class="progress-text" [ngClass]="{ 'progress-text--due': s.promptState === 'due' }">{{ vm.getPlanProgressLabel(c) }}</span>
							</div>
						</ng-container>
						<ng-template #surveysMeter>
							<div class="progress-cell">
								<div class="progress-track">
									<div
										class="progress-fill"
										[ngClass]="progressFillClass(s.surveysCompleted, s.surveysTotal)"
										[style.width.%]="progressPercent(s.surveysCompleted, s.surveysTotal)"></div>
								</div>
								<span class="progress-text">{{ s.surveysCompleted }} / {{ s.surveysTotal }}</span>
							</div>
						</ng-template>
					</div>
				</div>
			</div>
			<div class="toolkit__themeTags" *ngIf="hasVisiblePrompt(c) && effectivePrompt(c) as prompt">
				<span class="toolkit__themeTag">{{ vm.getPromptStateLabel(prompt) }}</span>
				<span class="toolkit__clientMeta">{{ vm.getPromptSummary(prompt) }}</span>
			</div>
			<div class="toolkit__promptCallout" *ngIf="isReassessmentDue(s)">
				<div class="toolkit__promptCalloutBody">
					<div class="toolkit__promptCalloutTitle">{{ reassessmentTitle(s) }}</div>
					<div class="toolkit__promptCalloutText">{{ reassessmentBody(c) }}</div>
				</div>
				<button
					type="button"
					class="toolkit__actionBtn toolkit__actionBtn--prompt"
					(click)="vm.startPromptAssign(c)">{{ promptActionLabel(c) }}</button>
			</div>
			<div class="toolkit__actionsRow">
				<button
					type="button"
					class="toolkit__actionBtn toolkit__actionBtn--primary"
					(click)="isReassessmentDue(s) ? vm.startAssignForClient(c) : handlePromptAction(c)">{{ isReassessmentDue(s) ? ('Toolkit.Provider.Client.Actions.AssignOther' | translate) : (hasVisiblePrompt(c) ? promptActionLabel(c) : ('Toolkit.Provider.Client.Actions.Assign' | translate)) }}</button>
				<button type="button" class="toolkit__actionBtn" (click)="openChat(c)">{{ 'Toolkit.Clients.Actions.OpenChat' | translate }}</button>
			</div>
		</ng-container>
	</div>

	<div *ngIf="!vm.filteredClients?.length" class="toolkit__emptyPane">
		<div class="toolkit__emptyTitle">{{ 'Toolkit.Clients.Empty' | translate }}</div>
	</div>
</div>
